import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8056 29.8333L6.41675 20.4444L8.40283 18.4583L15.8056 25.8611L31.5695 10.0972L33.5556 12.0833L15.8056 29.8333Z",
		fill: "inherit"
	})
});
export default SvgCheck;
